import { VideoInputComponentIcon } from './VideoInputComponentIcon';

/**
 * author: Google
 * id 55F413A7-319D-4419-87D4-97FF9ED96791
 * name video-input-component
 * version: 2.1.19
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/video-input-component.svg
 * tags
 * - Video / Movie 
 */
export const VideoInputCompositeIcon = VideoInputComponentIcon;
export default VideoInputCompositeIcon